import { ToggleButton, ToggleLabel } from './styled';
import { pluralise } from '@/utilities/pluralise';
import If from '@/components/If';

interface Props {
  light?: boolean;
  onClick: () => void;
  expand: boolean;
  listingCount: number;
}

export const Toggle = (props: Props) => {
  return (
    <ToggleButton
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        props.onClick();
      }}
      light={props.light}
    >
      <If
        conditions={{
          collapsed: !props.expand,
          expanded: props.expand,
        }}
      >
        {{
          collapsed: (
            <ToggleLabel light={props.light}>
              {`+ ${props.listingCount} ${pluralise(
                props.listingCount,
                'listing',
                'listings'
              )}`}
            </ToggleLabel>
          ),
          expanded: <ToggleLabel light={props.light}>show less</ToggleLabel>,
        }}
      </If>
    </ToggleButton>
  );
};
